import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';

import {Group} from 'shared/models/target-groups/group';

@Injectable()
export class GroupsRepository {

  constructor(private http: Http) { }

  public getAllGroups(): Observable<Array<Group>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.groups}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getGroup(id: String): Observable<Group> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.groups}/${id}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public createGroup(group: Group): Observable<Group> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: String = JSON.stringify(group);

    return this.http.post(`${environment.targetGroups.groups}`, body, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public updateGroup(group: Group): Observable<Group> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: String = JSON.stringify(group);

    return this.http.put(`${environment.targetGroups.groups}/${group._id}`, body, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public deleteGroup(group: Group): Observable<boolean> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.delete(`${environment.targetGroups.groups}/${group._id}`, options)
      .map((response: Response) => {
        return response.ok;
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/groups/repositories/groups.repository.ts